/** @jsxImportSource @emotion/react */
import React, { forwardRef } from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Amount } from "../../../types/amount";
import { BalancePercentageOptionsEnum } from "./BalancePercentages";
import { Hash } from "viem";
import { isAddressEqual } from "../../../utils/tokenUtils";
import { CurrencyInputNew } from "../../general/CurrencyInput/CurrencyInputNew";
import { noop } from "lodash-es";

export interface AmountInputProps {
  tokenAddress: Hash;
  setBalancePercentageActive: React.Dispatch<
    React.SetStateAction<BalancePercentageOptionsEnum | undefined>
  >;
  isVisible: boolean;
}

const AmountInput = forwardRef<HTMLInputElement, AmountInputProps>(
  ({ tokenAddress, setBalancePercentageActive, isVisible }, ref) => {
    const selectedToken = GlobalStore.useState(s => {
      return s.takerTokens.find(e => isAddressEqual(e.tokenAddress, tokenAddress));
    });
    const updateStore = (value: Amount) => {
      setBalancePercentageActive(undefined);
      GlobalStore.update(s => {
        s.takerTokens = s.takerTokens.map(e => {
          if (isAddressEqual(e.tokenAddress, tokenAddress)) {
            e.amount = value;
          }
          return e;
        });
      });
    };
    return (
      <CurrencyInputNew
        ref={ref}
        isVisible={isVisible}
        onChange={value => {
          try {
            const amount = new Amount(value);
            updateStore(amount);
          } catch (e) {
            noop();
          }
        }}
        value={selectedToken?.amount.value.toString() ?? "0"}
        formatter={value => (value === "0" ? "0" : value)}
      />
    );
  }
);

export default AmountInput;
